import { render, staticRenderFns } from "./DeleteDeviceModalSection.vue?vue&type=template&id=1c7dd814"
import script from "./DeleteDeviceModalSection.vue?vue&type=script&lang=js"
export * from "./DeleteDeviceModalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports